const user = {
  state: {
    userInfo: {},
    prodList: []
  },
  getters: {
    getUserInfo(state) {
      return state.userInfo.id ? state.userInfo : localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : state.userInfo
    },
    getProdList(state) {
      return state.prodList.length > 0 ? state.prodList : localStorage.getItem('prodList') ? JSON.parse(localStorage.getItem('prodList')) : []
    }
  },
  mutations: {
    updateUserInfo(state, record) {
      localStorage.setItem('userInfo', JSON.stringify(record))
      state.userInfo = record
    },
    updateProdList(state, record) {
      localStorage.setItem('prodList', JSON.stringify(record || []))
      state.prodList = record || []
    }
  }
}

export default user
